import { Button } from '@tremor/react';
import { t } from '../lib/i18n';

interface PrintButtonProps {
  /** Optional: sets document.title before printing so the browser's
   *  "Save as PDF" default filename is meaningful. Restored via afterprint. */
  documentTitle?: string;
  /** Button label. Defaults to t.print.button ("Imprimir"). */
  label?: string;
}

/**
 * A small "Imprimir" button that calls window.print() after optionally
 * setting document.title so the browser's Save-as-PDF dialog defaults to a
 * sensible filename.  The button carries `no-print` so it vanishes in the
 * printed output.
 */
export default function PrintButton({ documentTitle, label }: PrintButtonProps) {
  function handlePrint() {
    if (documentTitle) {
      const prev = document.title;
      document.title = documentTitle;
      const restore = () => {
        document.title = prev;
        window.removeEventListener('afterprint', restore);
      };
      window.addEventListener('afterprint', restore);
    }
    window.print();
  }

  return (
    <Button
      size="xs"
      variant="secondary"
      className="no-print"
      onClick={handlePrint}
    >
      {label ?? t.print.button}
    </Button>
  );
}
